import { api } from './client.js'
import { endpoints } from './endpoints.js'
import { unwrapList } from '../utils/format.js'

// Thin read helper over the DoctorProfile directory (`GET /api/doctors/`).
//
// The backend DoctorProfileViewSet exposes `?search=` (username, first/last
// name, specialty, place_of_work) and a `user_type` filter ("doctor" |
// "specialist"). Any authenticated user may list/retrieve. Rows come back as
// DoctorProfileSerializer:
//   { id, user_id, username, full_name, email, user_type, specialty,
//     qualifications, place_of_work, ... }
//
// Tolerates both a raw list and a paginated DRF { results: [...] } envelope
// via unwrapList, matching the other catalogue helpers.
export async function listDoctors({ search, userType } = {}) {
  const { data } = await api.get(endpoints.doctorList, {
    params: {
      search: search || undefined,
      user_type: userType || undefined,
    },
  })
  return unwrapList(data)
}
